const $win = $(window);

function equalizeHeight() {
  if ($win.width() < 768) {
    return false;
  }
  const $holder = $(".stores .inner");
  $(".stores .map--desktop").add($(".stores .store__aside")).height($holder.height());
}

let timed;
$win.on("resize load", function() {
  clearTimeout(timed);
  timed = setTimeout(function() {
    equalizeHeight();
  }, 100);
});



// WEBPACK FOOTER //
// ../assets/js/equalize-height.js